import React from 'react';
import { Header, Grid, Button } from 'semantic-ui-react';

const MoreLinks = () => (
  <>
    <Header as="h2" content="More" />
    <Grid columns={4} stackable centered className="more-links">
      <Grid.Row>
        <Grid.Column textAlign="center">
          <Button
            fluid
            className="link"
            as="a"
            href="https://www.twr360.org"
            content="Home"
            icon="home"
          />
        </Grid.Column>
        <Grid.Column textAlign="center">
          <Button
            fluid
            className="link"
            as="a"
            href="https://www.twr360.org/ministries"
            content="Ministries"
            icon="heart"
          />
        </Grid.Column>
        <Grid.Column textAlign="center">
          <Button
            fluid
            className="link"
            as="a"
            href="https://www.twr360.org/topics"
            content="Topics"
            icon="tags"
          />
        </Grid.Column>
        <Grid.Column textAlign="center">
          <Button
            fluid
            className="link"
            as="a"
            href="https://www.twr360.org/knowing-god"
            content="Knowing God"
            icon="question circle"
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </>
);

export default MoreLinks;
